export const CONTACT_INFO = {
    address: {
        street: 'Mattackerweg 4',
        city: 'Muri Bern',
        zip: '3074',
        country: 'Switzerland',
    },
    email: {
        general: 'office@constantinalifestyle.one',
        support: 'office@constantinalifestyle.one',
        bookings: 'konstantina@constantinalifestyle.one',
    },
    phone: {
        main: '+41 31 321 45 67',
    },
    companyName: 'Constantina Lifestyle',
};

export const APP_CONFIG = {
    NAME: "Constantina's Styling Advisor",
    DOMAIN: "https://www.constantinalifestyle.one",
    BACKEND_BASE_URL: 'https://api.constantina.one/v1',
    VERSION: "1.0.6",
    EMAIL_TO: 'office@constantinalifestyle.one',
    EMAIL_FROM: 'office@constantinalifestyle.one',
    EMAIL_FROM_NAME: 'Constantina AI Stylist',
    EMAIL_PROVIDER: 'emailjs',
    GA_TRACKING_ID: 'G-N3R470CBGW',
    ADMIN_PASSWORD: process.env.ADMIN_PASSWORD || 'Admin123!',
};

export const BACKEND_CONFIG = {
    /** Set to true to use the real backend API instead of localStorage */
    USE_EXTERNAL_BACKEND: false,
    /** Backend API base URL — override in project config if needed */
    BACKEND_URL: 'http://localhost:3000',
};

export const SOCIAL_LINKS = {
    LINKEDIN: "https://www.linkedin.com/company/constantinalifestyle",
    INSTAGRAM: "https://instagram.com/constantinalifestyle.369",
    PINTEREST: "https://pinterest.com/constantinalifestyle",
    TIKTOK: "https://tiktok.com/@constantinalifestyle.369",
    TWITTER: "https://x.com/constantinalifestyle",
    FACEBOOK: "https://facebook.com/constantinalifestyle.369",
    YOUTUBE: "https://youtube.com/@Constantinalifestyle-369"
};

export const CDN_URLS = {
    PEXELS: 'https://images.pexels.com/',
    UNSPLASH: 'https://images.unsplash.com/',
    GCS: 'https://storage.googleapis.com/codina-outfit-assets/',
    GITHUB: 'https://raw.githubusercontent.com/',
    LOGO: 'https://www.constantinalifestyle.one/logo_constantina_transparent.png',
    BLOG: 'https://diary.constantinalifestyle.one/blog',
    GOOGLE_PHOTOS: 'https://lh3.googleusercontent.com/',
    GOOGLE_DRIVE: 'https://lh3.googleusercontent.com/d/',
    OCI_STORE: 'https://objectstorage.eu-zurich-1.oraclecloud.com/p/oL9PouClcPbWyMOLJP6tMnAoZ_6gigLvQMA8Ms825D5YMYH5vv3J7i114ukHbzWV/n/zrtpnntkgyvg/b/codina_aistudio/o/',
};

export const OCI_FOLDERS = {
    ABOUT: 'web_about/',
    BLOG: 'web_blog/',
    CONTENT: 'web_content/',
    HOMEPAGE: 'web_homepage/',
    LOOKBOOKS: 'web_lookbooks/',
    PORTFOLIO: 'web_portfolio/',
    REFERENCES: 'web_references/',
};

export const RESOURCE_LINKS = {
    MINIMALISM_PDF: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}PDF/Minimalism_Guide.pdf`,
    COLOR_THEORY_PDF: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}PDF/Color_Theory_Masterclass.pdf`,
    EXECUTIVE_STYLE_PDF: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}PDF/Executive_Presence.pdf`,
    CAPSULE_WARDROBE_PDF: `${CDN_URLS.OCI_STORE}${OCI_FOLDERS.CONTENT}PDF/Capsule_Wardrobe_Blueprint.pdf`,
};

export const GEMINI_MODELS = {
    GEMINI_2_5_PRO: 'gemini-2.5-pro',
    GEMINI_2_5_FLASH: 'gemini-2.5-flash',
    GEMINI_2_5_FLASH_IMAGE: 'gemini-2.5-flash-image',
    GEMINI_2_5_FLASH_LITE: 'gemini-2.5-flash-lite',
    GEMINI_2_0_FLASH: 'gemini-2.0-flash',
    GEMINI_2_0_PRO: 'gemini-2.0-pro-exp-02-05',
    GEMINI_2_0_FLASH_THINKING: 'gemini-2.0-flash-thinking-exp-1219',
    GEMINI_1_5_PRO: 'gemini-1.5-pro',
    GEMINI_1_5_FLASH: 'gemini-1.5-flash',
    GEMINI_3_PRO: 'gemini-3.0-pro-preview',
    GEMINI_3_FLASH: 'gemini-3.0-flash-preview',
    GEMINI_3_PRO_IMAGE: 'gemini-3-pro-image-preview',
    GEMINI_3_1_PRO: 'gemini-3.1-pro-preview',
    GEMINI_3_1_FLASH: 'gemini-3.1-flash-preview',
    GEMINI_3_1_FLASH_IMAGE: 'gemini-3.1-flash-image-preview',

    GEMINI_VEO_VIDEO: 'veo-1.0-generate-001',
    FLASH_TEXT: 'gemini-3.1-flash-preview',//'gemini-2.5-flash',
    PRO_TEXT: 'gemini-3.1-pro-preview',//'gemini-2.5-pro',
    DEEP_THINK: 'gemini-3.1-pro-preview',//'gemini-2.0-flash-thinking-exp-1219',
    VEO_3_1_FAST: 'veo-3.1-fast-generate-preview',
    VEO_3_1_LITE: 'veo-3.1-lite-generate-preview',
};

const DEFAULT_API_KEYS = {
    GOOGLE_CALENDAR: process.env.GOOGLE_CALENDAR_API_KEY || 'AIzaSyBxQu9rRWGzDAwhbIBryY7qE3aM5oCk_4E',
    googleApiKey: process.env.GOOGLE_API_KEY || process.env.VITE_GOOGLE_API_KEY || 'AIzaSyBxQu9rRWGzDAwhbIBryY7qE3aM5oCk_4E',
    gemini: process.env.GEMINI_API_KEY || process.env.VITE_GEMINI_API_KEY || 'AIzaSyBxQu9rRWGzDAwhbIBryY7qE3aM5oCk_4E',
    googleWorkspace: {
        clientId: process.env.GOOGLE_WORKSPACE_CLIENT_ID || '167627474891-aktk66ic3ven3jdkjvpj1dn2ae2t6s6i.apps.googleusercontent.com',
        clientSecret: process.env.GOOGLE_WORKSPACE_CLIENT_SECRET || 'PLACEHOLDER_CLIENT_SECRET',
        refreshToken: process.env.GOOGLE_WORKSPACE_REFRESH_TOKEN || 'PLACEHOLDER_REFRESH_TOKEN',
    },
    emailjs: {
        serviceId: 'service_1eahlgh',
        templateId: 'template_4cyam4q',
        publicKey: 'bd67rMzSM3HXWPKg3',
        accessToken: 'j2YXraVWnVyrh2MpCHI0b'
    }
};

// Singleton pattern to ensure same object across multiple module loads in tests
if (!(globalThis as any)._SHARED_API_KEYS) {
    (globalThis as any)._SHARED_API_KEYS = { ...DEFAULT_API_KEYS };
}

export const API_KEYS = (globalThis as any)._SHARED_API_KEYS;

/**
 * Helper to update API keys at runtime (useful for tests)
 */
export const updateApiKeys = (keys: Partial<typeof DEFAULT_API_KEYS>) => {
    Object.assign(API_KEYS, keys);
};

export const GCP_CONFIG = {
    projectId: process.env.GCP_PROJECT_ID || 'codina-outfit',
    bucketName: process.env.GCP_BUCKET_NAME || 'codina-outfit-user-content',
    location: process.env.GCP_LOCATION || 'europe-west6',
};

export const API_CONFIG = {
    BACKEND_BASE_URL: APP_CONFIG.BACKEND_BASE_URL,
    ENDPOINTS: {
        TRANSFORM_IMAGE: 'transform-image',
        GENERATE_OUTFIT: 'generate-outfit',
        FIND_RETAILERS: 'find-retailers',
        STYLING_ADVICE: 'styling-advice',
        ANALYZE_FEATURES: 'analyze-features',
    }
};

export const GEMINI_CONFIG = {
    VISION_MODEL: GEMINI_MODELS.GEMINI_2_5_FLASH_IMAGE,
    TEXT_MODEL: GEMINI_MODELS.GEMINI_2_5_FLASH,
    MULTIMODAL_MODEL: GEMINI_MODELS.GEMINI_2_5_PRO,
    FLASH_TEXT: GEMINI_MODELS.GEMINI_2_5_FLASH,
    PRO_TEXT: GEMINI_MODELS.GEMINI_2_5_PRO,
    THINKING: GEMINI_MODELS.GEMINI_3_1_PRO,
    VIDEO: GEMINI_MODELS.VEO_3_1_LITE,
    TRY_ON: GEMINI_MODELS.GEMINI_3_1_FLASH_IMAGE, //GEMINI_2_5_FLASH_IMAGE, // Fallback if no specific try-on
};

export const LANGUAGE_CONFIG = {
    DEFAULT_LANGUAGE: 'en',
    SUPPORTED_LANGUAGES: ['en', 'de', 'fr', 'es', 'it'],
};

export const MULTI_CDN_CONFIG = {
    PORTFOLIO: ['https://images.unsplash.com/', 'https://storage.googleapis.com/codina-outfit-assets/', 'https://objectstorage.eu-zurich-1.oraclecloud.com/p/oL9PouClcPbWyMOLJP6tMnAoZ_6gigLvQMA8Ms825D5YMYH5vv3J7i114ukHbzWV/n/zrtpnntkgyvg/b/codina_aistudio/o/'],
    WARDROBE: ['https://raw.githubusercontent.com/', 'https://storage.googleapis.com/codina-outfit-assets/', 'https://images.pexels.com/'],
    BLOG: ['https://images.pexels.com/', 'https://images.unsplash.com/', 'https://storage.googleapis.com/codina-outfit-assets/', 'https://objectstorage.eu-zurich-1.oraclecloud.com/p/oL9PouClcPbWyMOLJP6tMnAoZ_6gigLvQMA8Ms825D5YMYH5vv3J7i114ukHbzWV/n/zrtpnntkgyvg/b/codina_aistudio/o/'],
    CANVAS: ['https://storage.googleapis.com/codina-outfit-assets/', 'https://objectstorage.eu-zurich-1.oraclecloud.com/p/oL9PouClcPbWyMOLJP6tMnAoZ_6gigLvQMA8Ms825D5YMYH5vv3J7i114ukHbzWV/n/zrtpnntkgyvg/b/codina_aistudio/o/'],
    UI: ['https://raw.githubusercontent.com/', 'https://storage.googleapis.com/codina-outfit-assets/', 'https://objectstorage.eu-zurich-1.oraclecloud.com/p/oL9PouClcPbWyMOLJP6tMnAoZ_6gigLvQMA8Ms825D5YMYH5vv3J7i114ukHbzWV/n/zrtpnntkgyvg/b/codina_aistudio/o/']
};

export const STORAGE_KEYS = {
    LANGUAGE: 'language',
    THEME: 'appTheme',
    AUTH_USER: 'authUser',
    USERS_DB: 'users_db',
    USER_PROFILE_PREFIX: 'user_profile_',
    // Component specific keys
    OUTFIT_FINDER_COLOR: 'outfitFinder_color',
    OUTFIT_FINDER_OCCASION: 'outfitFinder_occasion',
    OUTFIT_FINDER_SEASON: 'outfitFinder_season',
    OUTFIT_FINDER_STYLE: 'outfitFinder_style',
    OUTFIT_FINDER_GENDER: 'outfitFinder_gender',
    OUTFIT_FINDER_BUDGET: 'outfitFinder_budget',
    SAVED_PHOTO_STYLE: 'savedPhotoStyle',
    SAVED_CUSTOM_PROMPT: 'savedCustomPhotoPrompt',
    WARDROBE_PREFIX: 'wardrobe_items_',
    ADVISOR_CONTEXT: 'advisorContext',
    STYLING_IMAGE: 'stylingImage',
};

export const OCI_LOGGING_CONFIG = {
    MOCK_LOGS: true, // Enable for safer dev/test without real OCI setup
    NAMESPACE: process.env.OCI_LOGGING_NAMESPACE || 'codina_logs',
    LOG_GROUP_ID: process.env.OCI_LOGGING_GROUP_ID || 'ocid1.loggroup.oc1...',
    REGION: process.env.OCI_REGION || 'eu-zurich-1',
    ENDPOINT: process.env.OCI_LOGGING_ENDPOINT || 'https://ingestion.loganalytics.eu-zurich-1.oraclecloud.com',
    PRIVATE_KEY: process.env.OCI_PRIVATE_KEY || '...PRIVATE KEY...',
    KEY_FINGERPRINT: process.env.OCI_KEY_FINGERPRINT || '...FINGERPRINT...',
    TENANCY_ID: process.env.OCI_TENANCY_ID || 'ocid1.tenancy.oc1...',
    USER_ID: process.env.OCI_USER_ID || 'ocid1.user.oc1...',
};

export const FIREBASE_CONFIG = {
    PROJECT_ID: process.env.FIREBASE_PROJECT_ID || 'teak-inquiry-477422-s4',
    CLIENT_EMAIL: process.env.FIREBASE_CLIENT_EMAIL || 'konstantina-service@teak-inquiry-477422-s4.iam.gserviceaccount.com',
    PRIVATE_KEY: process.env.FIREBASE_PRIVATE_KEY  || 'AIzaSyD5c9VN2xuwEggRAWgduWU70umrWHWRecQ',
    STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET  || 'teak-inquiry-477422-s4.firebasestorage.app',
    USE_FIREBASE_CONFIG_STORAGE: process.env.USE_FIREBASE_CONFIG_STORAGE === 'true' || false,
    DATABASE_ID: process.env.FIREBASE_DATABASE_ID || 'codinaweb01',
};

// Your web app's Firebase configuration
export const FIREBASE_CLIENT_CONFIG = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyD5c9VN2xuwEggRAWgduWU70umrWHWRecQ",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || `${FIREBASE_CONFIG.PROJECT_ID}.firebaseapp.com`,
  projectId: FIREBASE_CONFIG.PROJECT_ID,
  storageBucket: FIREBASE_CONFIG.STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "167627474891",
  appId: process.env.FIREBASE_APP_ID || "1:167627474891:web:fd74a940297f9fc794584e",
  databaseId: FIREBASE_CONFIG.DATABASE_ID
};

export const EMAIL_CONFIG = {
    USER: process.env.EMAIL_USER,
    PASS: process.env.EMAIL_PASS,
};

export const SOCIAL_API_CONFIG = {
    INSTAGRAM: {
        ACCESS_TOKEN: process.env.INSTAGRAM_ACCESS_TOKEN,
    },
    YOUTUBE: {
        API_KEY: process.env.YOUTUBE_API_KEY,
        CHANNEL_ID: process.env.YOUTUBE_CHANNEL_ID,
    },
};

export const GOOGLE_CONFIG = {
    CALENDAR: {
        CLIENT_EMAIL: process.env.GOOGLE_CALENDAR_CLIENT_EMAIL || process.env.GOOGLE_CLIENT_EMAIL,
        PRIVATE_KEY: process.env.GOOGLE_CALENDAR_PRIVATE_KEY || process.env.GOOGLE_PRIVATE_KEY,
        CALENDAR_ID: process.env.GOOGLE_CALENDAR_ID || 'primary',
        API_KEY: process.env.GOOGLE_CALENDAR_API_KEY,
    }
};

// Backwards compatibility or specific service keys
export const API_KEYS_EXTENDED = {
    ...API_KEYS,
    google: GOOGLE_CONFIG.CALENDAR
};

// Aliases for common access patterns in services
export const apiKeys = API_KEYS;
export const socialIntegrations = {
    instagram: {
        appId: 'placeholder',
        appSecret: 'placeholder',
        accessToken: SOCIAL_API_CONFIG.INSTAGRAM.ACCESS_TOKEN
    },
    youtube: {
        apiKey: SOCIAL_API_CONFIG.YOUTUBE.API_KEY,
        playlistId: SOCIAL_API_CONFIG.YOUTUBE.CHANNEL_ID
    },
    twitter: {
        apiKey: 'placeholder'
    },
    facebook: {
        appId: 'placeholder'
    }
};
